import React from 'react';
import { makeStyles,useTheme } from '@material-ui/core/styles';
import {
  Box,
  useMediaQuery
} from '@material-ui/core';
import bgImage1 from '../../../../assets/images/Home_Images/bg1.png'
import { fade } from '@material-ui/core/styles/colorManipulator';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: '35vh',
  },
  sectionTwo: {
    fontFamily: 'Helvetica Neue',
    backgroundColor: fade('#fafafa', .2),
  },

  innerGridHeading: {
    width: "100%",
    textAlign: "center",
    fontSize: '3rem',
    color: fade('#bdbdbd', 1),
    paddingLeft: 20,
    paddingRight: 20,
    
  },
  
  innerGridHeadingMobile: {
    width: "100%",
    textAlign: "center",
    fontSize: '2.5rem',
    color: fade('#bdbdbd', 1),
    paddingLeft: 20,
    paddingRight: 20,
    
  },
  sectionParagraph: {
    margin: "20px 0px",
    fontSize: '1rem',
    width: "100%",
    textAlign: "center",
    color: fade('#bdbdbd', 1),
  },
  innerGridContainer: {
    paddingTop: '14vh',
    paddingBottom: '15vh',
  },
}));

export default function Home() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <div className={classes.root} style={{ backgroundImage: `url(${bgImage1})` }}>
      <Box className={classes.sectionTwo}>
        <Box className={classes.innerGridContainer}
          container spacing={1} >
          <h1 className={isMobile? classes.innerGridHeading: classes.innerGridHeadingMobile} >
            "Marketers that dont understand the power of music will simply be left behind"
          </h1>
          <p className={classes.sectionParagraph}>McDonald's, CMO Mary Dillon</p>
        </Box>
      </Box>
    </div >

  )
}